import React from 'react';
import styled from 'styled-components';
import { circle } from '../../../../styles/function';
import { font, colors } from '../../../../styles/variables';

const RadioPattern = styled.div`
label{
  color: ${font.color.default};
  display: inline-block;
  padding-left: 24px;
  position: relative;
  &:before, &:after{
    content: '';
    display: inline-block;
    position: absolute;
    transition: all 0.3s ease;
  }

  &:before{
    ${circle('20px')};
    background-color: #ddd;

    top: 0;
    left: 0;
    z-index: 1;
  }

  &:after{
    ${circle('12px')};
    background-color: #fff;

    top: 4px;
    left: 4px;
    z-index: 99;
  }
}
input[type=radio]{
  display: none;
  &:checked{
    + label{
      &:before{
        background-color: ${colors.primary.default};
      }
    }
  }
}
`;

const Radio = props => (
  <RadioPattern>
    <input
      type="radio"
      name={props.name}
      id={props.id}
      defaultChecked={props.defaultChecked}
      checked={!!props.checked}
      onChange={props.onChange}
    />
    <label htmlFor={props.id}>{props.children}</label>
  </RadioPattern>
);

export default Radio;
